import { getSearchParamFlag } from '../utils/searchParams';
import { enableTestMode } from '@sas-dvr/internal-va-react-core/config';

export const e2eMode = getSearchParamFlag('VASDK_E2EMODE') ?? false;

if (e2eMode) {
  enableTestMode();
}
